import React from 'react';
import { useTranslation } from 'react-i18next';
import { FaIcon } from '../FaIcon';

export function MixedCurrencyWarning({ currencies }) {
    const { t } = useTranslation();

    if (!Array.isArray(currencies) || currencies.length < 2) {
        return null;
    }

    const currenciesText = currencies.join(' · ');

    return (
        <div className="mixed-currency-warning" role="status">
            <FaIcon iconName="triangle-exclamation" className="mixed-currency-warning__icon" />
            <span className="mixed-currency-warning__text">
                {t('data_explorer.mixed_currency.warning_text', { currencies: currenciesText })}
            </span>
            <div className="info-icon-container mixed-currency-warning__info">
                <FaIcon iconName="circle-info" />
                <div className="warning-tooltip -below-right -rich">
                    <div className="warning-tooltip-body">
                        <p
                            className="warning-tooltip-text"
                            dangerouslySetInnerHTML={{
                                __html: t('data_explorer.mixed_currency.warning_tooltip'),
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}
